import { render } from "./NotificationDetail.vue?vue&type=template&id=21865792&scoped=true"
import script from "./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&lang=js"

import "./NotificationDetail.vue?vue&type=style&index=0&id=21865792&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21865792"]])

export default __exports__